import { saveAs } from 'file-saver';
import { request } from '../../../utils/axios';
import { getHeaders } from '../../../utils/commonMethods';
import { DownloadOutputType } from './download-fields.constant';
import moment from 'moment';
import { AppConstants } from '../../../utils/app.constants';

export async function downloadFieldsUsingAPI(
  property: { id: string; name: string },
  field_ids: string[],
  output_type: DownloadOutputType = DownloadOutputType.GEOJSON,
  date = moment().utc().format(AppConstants.DATE_FORMATS.YYYY_DASH_MM_DASH_DD)
) {
  if (
    property.id &&
    property.name &&
    field_ids?.length > 0 &&
    Object.values(DownloadOutputType).includes(output_type)
  ) {
    const res = await request.post(
      `/v2/properties/${property.id}/fields/download?output_type=${output_type}&date=${date}`,
      { field_ids },
      { headers: getHeaders().common, responseType: 'blob' }
    );
    if (res.status === 200 && res.data) {
      const suffix = output_type === DownloadOutputType.SHAPEFILE ? 'zip' : output_type;
      saveAs(res.data, `${property.name}.${suffix}`);
    }
    return res;
  } else {
    return Promise.reject(new Error('Invalid inputs'));
  }
}
